// extracted by mini-css-extract-plugin
export default {"brandPromo":"LG-z","carousel":"MG-z"};